/**
 * O canvas não resolve `var(--token)`: as cores chegam ao Chart.js já calculadas, lidas dos
 * tokens `--ds-*` (`tokens.colors.css`). A translucidez é composta sobre a cor do token.
 */
type ChartColor = "text" | "line" | "fill" | "grid" | "marker";

const TOKEN = "--ds-color-surface-0";
// Sem a folha de estilo (teste), o token não resolve e a cor cai no branco do próprio token.
const FALLBACK = "white";

/** Parcela da cor do token mantida em cada elemento do gráfico (o resto é transparente). */
const OPACIDADE: Record<ChartColor, number> = {
  text: 100,
  line: 100,
  fill: 28,
  grid: 12,
  marker: 85,
};

export function resolveChartColor(color: ChartColor): string {
  const base =
    typeof document === "undefined"
      ? ""
      : getComputedStyle(document.documentElement).getPropertyValue(TOKEN).trim();
  const cor = base || FALLBACK;
  const opacidade = OPACIDADE[color];

  return opacidade === 100 ? cor : `color-mix(in srgb, ${cor} ${opacidade}%, transparent)`;
}
